import moment from 'moment';
import StringUtils from '../utils/StringUtils';
import BaseServiceCrud from './BaseServiceCrud';
import {saveAs} from 'file-saver';

export default class PayrollService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();

        this.path = 'user-payroll';
    }

    getCriteria(criteria) {
        console.log(criteria);
        return this.objToQueryString({
            locale: criteria.locale,
            dateFrom: StringUtils.isBlank(criteria.dateFrom) ? null : moment(criteria.dateFrom).format(),
            dateTo: StringUtils.isBlank(criteria.dateTo) ? null : moment(criteria.dateTo).format(),
            status: criteria?.status?.enumValue,
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    generate(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/generate`, {
            method: 'POST',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    approve(elementId, force) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/approve/${elementId}`, {
            method: 'PUT',
            body: JSON.stringify({force: force}),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    reject(elementId) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/reject/${elementId}`, {
            method: 'PUT',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    export(elementId, name, type) {
        return this.fetch(
            `${this.domain}/${this.path}/export/${elementId}`,
            {
                method: 'POST',
            },
            {
                'Content-Type': 'application/json',
                Accept: 'application/octet-stream',
            }
        )
            .then((blob) => {
                saveAs(blob, `${name}.${type}`);
            })
            .catch((err) => {
                throw err;
            });
    }
}
